import React from 'react';
import { NumberFormatValues } from 'react-number-format';
import {
  DateField,
  FormCell,
  Grid,
  GridItem,
  Header3Text,
  ISpruceFieldProps,
  NumberInputStyled,
  PhoneNumberField,
  SpruceField,
} from 'ui-toolkit';
import { IWhoHasFocus } from './IWhoHasFocus';
import { TextFieldTW } from '../../../tailwindComponents/textInputTW/TextFieldTW';
import { MaritalStatusCreatable } from './MaritalStatusCreatable';
import { EditAddressDataEntry } from '../../../ui-toolkit/orders/components/EditPropertyAddress/EditAddressDataEntry';

interface IPartyFormProps {
  index: number;
  focus: IWhoHasFocus;
}

export const PersonForm: React.FC<IPartyFormProps> = ({ index, focus }) => {
  const fieldNameStart = `parties.${index}`;
  return (
    <Grid columnCount={12}>
      <TextFieldTW
        name={`${fieldNameStart}.firstName`}
        labelText={`First Name`}
        isRequired
        placeholder={'Johnny'}
        autoFocus={focus.doesAnyone && focus.partyIndex === index}
        data-test-id={`${fieldNameStart}.first_name`}
        className={'col-span-4'}
      />
      <TextFieldTW
        name={`${fieldNameStart}.middleName`}
        labelText={`Middle Name`}
        placeholder={'"L" or "Leroy"'}
        data-test-id={`${fieldNameStart}.middle_name`}
        className={'col-span-4'}
      />
      <TextFieldTW
        name={`${fieldNameStart}.lastName`}
        data-test-id={`${fieldNameStart}.last_name`}
        labelText={'Last Name'}
        isRequired
        placeholder={'Appleseed'}
        className={'col-span-4'}
      />
      <GridItem columnStart={'span 3'}>
        <SpruceField name={`${fieldNameStart}.ssn`}>
          {({ field, formik }: ISpruceFieldProps) => (
            <FormCell label={`Last 4 Digits Of SSN`} errorText={field.errorText} isRequired={false}>
              <NumberInputStyled
                {...field}
                data-test-id={field.name}
                allowEmptyFormatting={false}
                format={`***-**-####`}
                type={'tel'}
                placeholder={'***-**-####'}
                mask={`#`}
                onValueChange={({ value }: NumberFormatValues) => {
                  formik.setFieldTouched(field.name);
                  formik.setFieldValue(field.name, value ? value.trim() : value);
                }}
                onChange={() => void 0}
              />
            </FormCell>
          )}
        </SpruceField>
      </GridItem>
      <MaritalStatusCreatable
        name={`${fieldNameStart}.maritalStatus`}
        data-test-id={`${fieldNameStart}.marital_status`}
        className={'col-span-3'}
        labelText={'Marital Status'}
        placeholder={'Married, Unmarried, etc...'}
      />
      <TextFieldTW
        name={`${fieldNameStart}.email`}
        data-test-id={`${fieldNameStart}.email`}
        labelText={'Email'}
        className={'col-span-3'}
        placeholder={'johnnylappleseed@gmail.com'}
      />
      <div className={'col-span-3'}>
        <PhoneNumberField
          name={`${fieldNameStart}.phoneNumber`}
          label={`Phone Number`}
          data-test-id={`${fieldNameStart}.phone_number`}
        />
      </div>
      <GridItem columnStart={'span 3'}>
        <DateField
          name={`${fieldNameStart}.dateOfBirth`}
          label={`Date of Birth`}
          placeholder={`MM/DD/YYYY`}
          onlyPastDates={true}
        />
      </GridItem>
      <GridItem columnStart={'span 12'}>
        <Header3Text>Current Address</Header3Text>
      </GridItem>
      <GridItem columnStart={'span 12'}>
        <EditAddressDataEntry name={`${fieldNameStart}.address`} isCamelCase />
      </GridItem>
    </Grid>
  );
};
